<template>
    <div class="w-100 advanced-search">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col d-flex align-center" style="padding-left: 7px;">
              <div class="label">
                Search role:
              </div>
              <vx-tooltip
                class="am-tooltip"
                position="left"
                style="display: inline-block"
                text="Search as Embiber uses a search engine optimized for internal production."
              >
                <vs-button
                  color="primary"
                  type="border"
                  :class="{selected: isFullFilters}"
                  class="radiobtn search-btn mr-5"
                  @click="() => { this.$router.push('/advanced-search')}"
                >
                  <CustomSvg icon="embibe" :color="isFullFilters ? '#fff' : '#7367f0'" />
                  Embiber
                </vs-button>
              </vx-tooltip>
              <vx-tooltip
                class="am-tooltip"
                position="right"
                style="display: inline-block"
                text="The consumer search engine is optimized for speed and is what the end-user will see."
              >
                <vs-button
                  color="primary"
                  type="border"
                  :class="{selected: !isFullFilters}"
                  @click="() => { this.$router.push('/advanced-search-new')}"
                  class="radiobtn search-btn">
                  <CustomSvg icon="user" :color="!isFullFilters ? '#fff' : '#7367f0'" />
                  Consumer
                </vs-button>
              </vx-tooltip>
            </div>
            <div class="vx-col custom-input-group concepts-search" style="flex-grow: 1;">
                    <div class="d-flex align-center">
                        <div class="relative flex-grow">
                            <vs-input loading v-model="filters._search"
                                      style="width: 100%"
                                      @keypress.enter="fetchItems(false)"
                                      placeholder="Type at least 3 characters."
                                      class="has-icons"
                            />
                            <div class="icons">
                                <feather-icon v-if="filters._search" icon="XIcon"
                                              svgClasses="h-6 w-6 cursor-pointer"
                                              @click="clearSearch"
                                              style="opacity: 0.7; margin-right: 5px;"/>
                                <div v-if="isLoading" class="vs-input__loading"
                                     style="margin-left: 5px;"/>
                                <feather-icon
                                    v-else
                                    style="margin-right: 5px;"
                                    icon="SearchIcon" svgClasses="h-6 w-6" :class="{'active-search-btn': isLoading}"/>
                            </div>
                        </div>
                      <vs-button id="search-btn" class="ml-5" color="primary" @click="fetchItems(false)">
                        Search
                      </vs-button>
                    </div>
                </div>
          </div>
            <div class="vx-row gutter-half mb-5 mt-3 d-flex align-center">
                <div class="vx-col w-full sm:w-full md:w-1/4">
                    <div class="d-flex align-center">
                        <span class="label">LM Format: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select LM Format"
                                  :options="$store.state.learningMapFormats"
                                  label="name"
                                  @input="() => { getGoals() }"
                                  :reduce="item => item.id"
                                  v-model="filters.lm_format_id">
                            <template #list-header>
                                <li style="text-align: center" v-if="!$store.state.learningMapFormats.length">Loading LM Formats...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !goals.length}">
                    <div class="d-flex align-center">
                        <span class="label">Goal: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Goal"
                                  :options="goals"
                                  label="name"
                                  @input="() => { getGrades(); }"
                                  :reduce="item => item.name"
                                  :disabled="!goals.length"
                                  v-model="filters.goal">
                            <template #list-header>
                                <li style="text-align: center" v-if="!goals.length">Loading Goals...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !grades.length}">
                    <div class="d-flex align-center">
                        <span class="label">Grade: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Grade"
                                  :options="grades"
                                  label="name"
                                  @input="() => { getSubjects(); }"
                                  :disabled="!grades.length"
                                  :reduce="item => item.name"
                                  v-model="filters.exam">
                            <template #list-header>
                                <li style="text-align: center" v-if="!grades.length">Loading Grades...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !subjects.length}">
                    <div class="d-flex align-center">
                        <span class="label">Subject: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Subject"
                                  :options="subjects"
                                  label="name"
                                  :disabled="!subjects.length"
                                  :reduce="item => item.name"
                                  @input="() => { getUnits(); }"
                                  v-model="filters.subject">
                            <template #list-header>
                                <li style="text-align: center" v-if="!subjects.length">Loading Subjects...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half mb-5 d-flex align-center">
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex align-center" :class="{'filter-disabled': !units.length}">
                        <span class="label">Unit: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Unit"
                                  :options="units"
                                  label="name"
                                  :reduce="item => item.name"
                                  :disabled="!units.length"
                                  @input="() => { getChapters(); }"
                                  v-model="filters.unit">
                            <template #list-header>
                                <li style="text-align: center" v-if="!units.length">Loading Units...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex align-center" :class="{'filter-disabled': !chapters.length}">
                        <span class="label">Chapter: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Chapter"
                                  :options="chapters"
                                  label="name"
                                  :disabled="!chapters.length"
                                  :reduce="item => item.name"
                                  @input="() => { getTopics(); }"
                                  v-model="filters.chapter">
                            <template #list-header>
                                <li style="text-align: center" v-if="!chapters.length">Loading Chapters...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !topics.length}">
                    <div class="d-flex align-center">
                        <span class="label">Topic: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Topic"
                                  :options="topics"
                                  label="name"
                                  :clearable="false"
                                  :disabled="!topics.length"
                                  :reduce="item => item.name"
                                  v-model="filters.topic">
                            <template #list-header>
                                <li style="text-align: center" v-if="!topics.length">Loading Topics...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half">
                <div class="vx-col w-full">
                    <vx-input-group class="custom-input-group">
                        <div class="d-flex">
                            <span class="label">Media Type: </span>
                            <div class="vx-input-group-append flex-grow">
                                <div class="append-text btn-addon">
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    v-for="(v, i) in types"
                                    :key="i"
                                    @click="toggleMediaType(v.value)"
                                    class="radiobtn"
                                    :class="{selected: filters.asset_types.indexOf(v.value) !== -1}">
                                    {{v.name}}
                                  </vs-button>
                                </div>
                            </div>
                        </div>
                    </vx-input-group>
                </div>
            </div>
            <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters">
                <div class="vx-col w-full sm:w-full md:w-1/2">
                    <div class="d-flex">
                        <span class="label">Academic Reviewed: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('academic_reviewed', true)"
                                    class="radiobtn"
                                    :class="{selected: filters.academic_reviewed && filters.academic_reviewed !== 'any'}">
                                    Yes
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('academic_reviewed', false)"
                                    class="radiobtn"
                                    :class="{selected: !filters.academic_reviewed}">
                                    No
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('academic_reviewed', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.academic_reviewed === 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/2">
                    <div class="d-flex">
                        <span class="label">Artist Reviewed: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('artist_reviewed', true)"
                                    class="radiobtn"
                                    :class="{selected: filters.artist_reviewed && filters.artist_reviewed !== 'any'}">
                                    Yes
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('artist_reviewed', false)"
                                    class="radiobtn"
                                    :class="{selected: !filters.artist_reviewed}">
                                    No
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('artist_reviewed', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.artist_reviewed === 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters">
                <div class="vx-col w-full sm:w-full md:w-1/2">
                    <div class="d-flex">
                        <span class="label">Visibility: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'internal_only')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'internal_only'}">
                                    Internal Only
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'b2b')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'b2b'}">
                                    B2B
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'public')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'public'}">
                                    Public
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/2">
                    <div class="d-flex">
                        <span class="label">Readiness: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('published', false)"
                                    class="radiobtn"
                                    :class="{selected: !filters.published}">
                                    Draft
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('published', true)"
                                    class="radiobtn"
                                    :class="{selected: filters.published && filters.published !== 'any'}">
                                    Published
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('published', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.published === 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters">
              <div class="vx-col w-full sm:w-full md:w-1/2">
                <div class="d-flex">
                  <span class="label">Ar links: </span>
                  <div class="vx-input-group-append flex-grow">
                    <div class="append-text btn-addon">
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('is_ar_links', true)"
                        class="radiobtn"
                        :class="{selected: filters.is_ar_links && filters.is_ar_links !== 'any'}">
                        Yes
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('is_ar_links', false)"
                        class="radiobtn"
                        :class="{selected: !filters.is_ar_links}">
                        No
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('is_ar_links', 'any')"
                        class="radiobtn"
                        :class="{selected: filters.is_ar_links === 'any'}">
                        Any
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full sm:w-full md:w-1/2">
                <div class="d-flex">
                  <span class="label">3D animation: </span>
                  <div class="vx-input-group-append flex-grow">
                    <div class="append-text btn-addon">
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('is_animated', true)"
                        class="radiobtn"
                        :class="{selected: filters.is_animated}">
                        Yes
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('is_animated', false)"
                        class="radiobtn"
                        :class="{selected: !filters.is_animated}">
                        No
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row gutter-half d-flex align-center radio-btns" v-if="isFullFilters">
              <div class="vx-col w-full sm:w-full md:w-1/2">
                <div class="d-flex">
                  <span class="label">AR Readiness: </span>
                  <div class="vx-input-group-append flex-grow">
                    <div class="append-text btn-addon">
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('ar_reviewed', true)"
                        class="radiobtn"
                        :class="{selected: filters.ar_reviewed && filters.ar_reviewed !== 'any'}">
                        Yes
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('ar_reviewed', false)"
                        class="radiobtn"
                        :class="{selected: !filters.ar_reviewed}">
                        No
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="border"
                        @click="setRadioBtn('ar_reviewed', 'any')"
                        class="radiobtn"
                        :class="{selected: filters.ar_reviewed === 'any'}">
                        Any
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </vx-card>
        <vx-card>
          <div class="search-total-items">
            <div class="search-total-items-title">Total items:</div> <div class="search-total-items-value">{{ totalItems }}</div>
          </div>
        </vx-card>
        <div class="pr">
            <div class="loader-block loader-block2" v-if="isLoading" style="min-height: 200px;">
                <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                </div>
            </div>
            <div class="vx-row">
              <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 lg:w-1/5"
                   v-for="(item, index) in items" :key="index" @click="isAssetModal = item.asset_object_id">
                <AssetItem :item="item" :show-images="showImages" :isMyLibrary="true" />
              </div>
            </div>
            <div class="mb-5" style="text-align: center" v-if="items.length && items.length % (currentPage * itemsPerPage) === 0">
                <vs-button color="primary" :disable="isLoading" @click="loadMore" style="width: 150px">
                    Load more
                </vs-button>
            </div>
        </div>
      <assetModal :id="isAssetModal" :withLink="true" v-if="isAssetModal" v-on:closeModal="closeAssetModal"/>
    </div>
</template>

<script>

import axios from "axios";
import vSelect from 'vue-select'
import AssetItem from "../components/AssetItem";
import CustomSvg from "../components/CustomSvg";
import assetModal from "../components/modal/assetModal";

export default {
    name: "AdvSearch",
    components: {vSelect, AssetItem, CustomSvg, assetModal},
    props: {},
    data() {
        return {
            filters: {
                _search: "",
                subject: "",
                unit: "",
                chapter: "",
                topic: "",
                title: "",
                asset_types: [],
                // _start: 0,
                // _limit: 27,
                order_by: "updatedAt",
                order: "desc",
                academic_reviewed: 'any',
                artist_reviewed: 'any',
                visibility: 'any',
                published: 'any',
                lm_format_id: '',
                goal: '',
                exam: '',
                is_ar_links: 'any',
                is_animated: false,
                ar_reviewed: 'any'
            },
            subjects: [],
            units: [],
            chapters: [],
            topics: [],
            titles: [],
            goals: [],
            grades: [],
            types: this.$store.state.types,
            items: [],
            currentPage: 1,
            totalItems: 0,
            itemsPerPage: 15,
            totalPages: 0,
            showImages: true,
            isLoading: false,
            lmDebounce: false,
            lmFormats: [],
            cancelSearchToken: [],
          isAssetModal: false,
          isFullFilters: false
        }
    },
    computed: {
        componentName: () => {
            return "AdvancedSearchNew"
        },
        filtersObj() {
            return {
                user_id: 123,
                query: this.filters._search,
                goal: this.filters.goal,
                grade: this.filters.exam,
                subject: this.filters.subject,
                unit: this.filters.unit,
                chapter: this.filters.chapter,
                topic: this.filters.topic,
                title: this.filters.title,
                // asset_type: this.filters.asset_type,
                // asset_type: this.filters.asset_types.length ? this.filters.asset_types.join(',') : null,
                asset_type: this.filters.asset_types,
                // start: (this.currentPage - 1) * this.itemsPerPage,
                size: this.itemsPerPage,
                // order_by: this.filters.order_by,
                // order: this.filters.order,
                academic_reviewed: this.filters.academic_reviewed,
                artist_reviewed: this.filters.artist_reviewed,
                visibility: this.filters.visibility,
                published: this.filters.published,
                is_ar_links: this.filters.is_ar_links,
                is_animated: this.filters.is_animated,
                ar_reviewed: this.filters.ar_reviewed,
                // lm_format_id: this.filters.lm_format_id,
            }
        },
        filtersQuery() {
            return Object.keys(this.filtersObj).filter(k => (!this.filtersObj.topic || (k !== 'goal' && k !== 'grade' && k !== 'subject' && k !== 'unit' && k !== 'chapter' && k !== 'topic')) && (Boolean(this.filtersObj[k]) && this.filtersObj[k] !== 'any' || this.filtersObj[k] === 0 || (k === 'academic_reviewed' || k === 'artist_reviewed' || k === 'published' || k === 'is_ar_links' || k === 'ar_reviewed') && this.filtersObj[k] !== 'any')).map(k => k === 'asset_type' ? this.filtersObj[k].map(el => `filter=${k}:${el}`).join('&') : ['academic_reviewed', 'artist_reviewed', 'visibility', 'published', 'is_ar_links', 'ar_reviewed'].indexOf(k) !== -1 ? `filter=${k}:${this.filtersObj[k]}` : `${k}=${this.filtersObj[k]}`).join("&")
        },
        learnpathName() {
            return Object.keys(this.filtersObj).filter(k => (k === 'goal' || k === 'grade' || k === 'subject' || k === 'unit' || k === 'chapter' || k === 'topic') && Boolean(this.filtersObj[k])).map(k => `${this.filtersObj[k].toLowerCase()}`).join("--")
        }
    },
    mounted() {
      if (this.$route.name === 'advancedSearch') {
        this.isFullFilters = true;
      }
      this.$root.$on('update_advanced_search', (search) => {
        this.updateSearch();
      })
      this.$root.$on('update_as_type_filters', () => {
        let types = [];
        for (let k in this.$store.state.typeFilters) {
          if (this.$store.state.typeFilters[k]) {
            types.push(k);
          }
        }
        this.filters.asset_types = types;
      })
      this.updateSearch();
    },
    destroyed() {
      let types = JSON.parse(JSON.stringify(this.$store.state.typeFilters));
      for (let k in types) {
        types[k] = false;
      }

      this.$store.commit("setState", {typeFilters: types});
    },
    watch: {
        filtersObj(next, prev) {
          if (this.items.length) {
            // this.items = [];
            this.totalPages = 0;
          }
            // if (!compareObjects(next, prev)) {
            //     this.fetchItems()
            // }
        }
    },
    methods: {
      closeAssetModal() {
        this.isAssetModal = false;
      },
      updateSearch() {
        if (this.$store.state.searchQuery) {
          this.filters._search = this.$store.state.searchQuery;
          this.$store.commit("setState", {searchQuery: ''});
          this.handlePaginationChange();
        }
      },
        loadMore() {
            this.currentPage++;
            this.fetchItems(true);
        },
        getLMFormats() {
            let url = `/lm-formats?lm_type=learning_map` + '&search=' + '';
            this.$axios.get(url).then(res => {
                this.lmFormats = res.data._items;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        setRadioBtn(type, val) {
          if (type === 'asset_type') {
            let types = JSON.parse(JSON.stringify(this.$store.state.typeFilters));
            for (let k in types) {
              if (val === k) {
                types[k] = true;
              } else {
                types[k] = false;
              }
            }

            this.$store.commit("setState", {typeFilters: types});

            this.filters[type] = val;
          } else {
            this.filters[type] = val;
          }
        },
        toggleMediaType(type) {
            let ind = this.filters.asset_types.indexOf(type);
            if (ind === -1) {
                this.filters.asset_types.push(type)
            } else {
                this.filters.asset_types.splice(ind, 1)
            }
        },
        clear(fieldName) {
            const  map = ['goals', 'grades', 'subjects', 'units', 'chapters', 'topics', 'titles'].reverse();
            const clearMap = {
                goals: () => {this.goals = []; this.filters.goal = ''},
                grades: () => {this.grades = []; this.filters.exam = ''},
                subjects: () => {this.subjects = []; this.filters.subject = ''},
                units: () => {this.units = []; this.filters.unit = ''},
                chapters: () => {this.chapters = []; this.filters.chapter = ''},
                topics: () => {this.topics = []; this.filters.topic = ''},
                titles: () => {this.titles = []; this.filters.title = ''},
            }
            let ind = map.indexOf(fieldName);
            this.items = [];
            this.currentPage = 1;
            this.totalPages = 0;
            if (ind < 0) return;
            for (let i=0; i<=ind; i++) {
                clearMap[map[i]]();
            }
        },
        gradeOnChange(newVal) {
            if (newVal[0] !== this.filters.grade[0] || newVal[1] !== this.filters.grade[1]) {
                this.filters.grade = newVal;
                clearTimeout(this.gradeTimeout);
                this.gradeTimeout = setTimeout(()=> {
                    this.getSubjects();
                }, 1000)
            }

        },
        getGoals() {
            if (this.filters.lm_format_id) {
                this.clear("goals");
                let url = `/goals-list?id=${this.filters.lm_format_id}`;
                this.$axios.get(url).then(res => {
                  this.goals = Object.values(res.data)[0];
                }).catch(e => {
                    console.log(url, e.message)
                })
            }
        },
        getGrades() {
            this.clear("grades");
            let url = `/grades-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            this.$axios.get(url).then(res => {
              let d = Object.values(res.data)[0].sort(function(a, b) {
                return a.name.localeCompare(b.name, undefined, {
                  numeric: true,
                  sensitivity: 'base'
                });
              });
              this.grades = d;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getSubjects() {
            this.clear("subjects");
            let url = `/subject-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            this.$axios.get(url).then(res => {
                this.subjects = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getUnits() {
            this.clear("units");
            let url = `/units-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            url += '&subject=' + this.filters.subject;
            this.$axios.get(url).then(res => {
                this.units = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getChapters() {
            this.clear("chapters");
            let url = `/chapters-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            url += '&subject=' + this.filters.subject;
            url += '&unit=' + this.filters.unit;
            this.$axios.get(url).then(res => {
                this.chapters = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getTopics() {
            this.clear("topics");
            let url = `/topics-list?id=${this.filters.lm_format_id}`;
            url += '&goal=' + this.filters.goal;
            url += '&exam=' + this.filters.exam;
            url += '&subject=' + this.filters.subject;
            url += '&unit=' + this.filters.unit;
            url += '&chapter=' + this.filters.chapter;
            this.$axios.get(url).then(res => {
                this.topics = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getTitles() {
            this.clear('titles')
            let url = `/titles-list?${this.filtersQuery}`;
            this.$axios.get(url).then(res => {
                this.titles = res.data;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        clearSearch() {
            this.filters._search = "";
            this.isLoading = false;
            if (this.cancelSearchToken && this.cancelSearchToken.length && this.cancelSearchToken[0].cancel) {
              this.cancelSearchToken[0].cancel({err: "Operation canceled by user action."});
            }
        },
        handlePaginationChange(page) {
            if (page != this.currentPage) {
                this.fetchItems();
            }
        },
        getKveCode() {
          let items = ['topic'];
          let kveCode = null;
          for (let k in items) {
            if (this.filters[items[k]]) {
              let temp = this[items[k] === 'exam' ? 'grades' : items[k] + 's'].find(item => item.name === this.filters[items[k]]);
              if (temp && temp.code) {
                kveCode = temp.code;
                break;
              }
            }
          }

          return kveCode;
        },
        fetchItems(loadMore = false) {
            // if (this.filters._search.length < 3) return;
            this.isLoading = true;
            this.$root.addLoading('#search-btn');
            clearTimeout(this.fetchDebounce);
            this.fetchDebounce = setTimeout(() => {
                if (!loadMore) {
                    this.items = [];
                    this.currentPage = 1;
                }
                if (this.cancelSearchToken && this.cancelSearchToken[0] && this.cancelSearchToken[0].cancel) {
                  this.cancelSearchToken[0].cancel({err: "Operation canceled by new search.", newSearch: true});
                }
                this.conceptsLoading = true;
                this.cancelSearchToken = axios.CancelToken.source();
                let langMatch = this.filters._search.match(/[a-zA-Z0-9_]/g);
                let lang = !this.filters._search || langMatch ? 'en' : 'hi';
                let url = `https://preprodms.embibe.com/fs_ms/ampsearch?${this.filtersQuery}${this.filters.topic ? '&learnpath_name=' + this.learnpathName : ''}&start=${(this.currentPage - 1) * this.itemsPerPage}&locale=${lang}`;
                let kveCode = this.getKveCode();

                url = `${this.$route.name === 'advancedSearchNew' ? 'https://beta-api.embibe.com' : 'https://preprodms.embibe.com'}/fs_ms/v2/ampsearch?${this.filtersQuery}${kveCode ? '&filter=meta_kve_codes.keyword:' + kveCode : ''}&start=${(this.currentPage - 1) * this.itemsPerPage}&locale=${lang}`
                this.$axios.get(url, {cancelToken: this.cancelSearchToken.token}).then(res => {
                    if (res.data && res.data.content && res.data.content.length) {
                        this.items.push(...res.data.content);
                    }
                    if (res.data && res.data.metadata) {
                        this.totalItems = res.data.metadata.total
                    }

                    this.isLoading = false;
                    this.$root.removeLoading('#search-btn');
                    if (this.cancelSearchToken && this.cancelSearchToken[0]) {
                      this.cancelSearchToken = this.cancelSearchToken.slice(1);
                    }
                }).catch(e => {
                    console.log('catch_search', e)
                    this.isLoading = Boolean(e.message.newSearch);
                    this.$root.removeLoading('#search-btn');
                    if (this.cancelSearchToken && this.cancelSearchToken[0]) {
                      this.cancelSearchToken = this.cancelSearchToken.slice(1);
                    }
                })
            }, 500)
        },
    },
}
function compareObjects(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
}
</script>
